export enum StorageKeys {
  API_USER_DATA = 'app_api_user_data'
}
